import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem } from "namirasoft-core";
import { NamirasoftERPMetaDatabase, PartyInputRow, PartyRow, PartyTypeRow } from "namirasoft-erp";
import { NSBox, NSBoxBoolean, NSBoxEntity, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScope, ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { isEdit: boolean; }

export default class PartyEditPage extends Component<Props>
{
    PartyType = createRef<NSBoxEntity<PartyTypeRow>>();
    Name = createRef<NSBoxString>();
    Description = createRef<NSBoxTextArea>();
    Enabled = createRef<NSBoxBoolean>();

    override render()
    {
        let db = new NamirasoftERPMetaDatabase(this.props.account.token_manager, console.error);

        return (
            <ErpLayout<PartyRow, PartyInputRow>
                {...this.props}
                mode={ErpScopeMode.Select}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.party(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): PartyInputRow => ({
                                        company_id: ErpScope.getCompanyId() ?? "",
                                        branch_id: ErpScope.getBranchId() ?? "",
                                        party_type_id: this.PartyType.current?.getValueOne() ?? "",
                                        name: this.Name.current?.getValue() ?? "",
                                        description: this.Description.current?.getValue() ?? null,
                                        enabled: this.Enabled.current?.getValueBool() ?? true,
                                        party_category: [],
                                        party_tag: [],
                                        party_field: [],
                                    }),
                                    setRow: (row: PartyRow) =>
                                    {
                                        ErpScope.set({ company_id: row.company_id, branch_id: row.branch_id });
                                        this.PartyType.current?.setValueOne(row.party_type_id);
                                        this.Name.current?.setValue(row.name);
                                        this.Description.current?.setValue(row.description);
                                        this.Enabled.current?.setValueBool(row.enabled);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxEntity<PartyTypeRow>
                        ref={this.PartyType} title="Party Type" info={{ link: "https://namirasoft.com/erp/console-guide/party/#field-party-type-id" }} required multiple={false}
                        table_name="party_type" table={db.tables.party_type}
                        list={(filters, page, size, sorts) =>
                        {
                            let f: FilterItem[] = filters ? [...filters] : [];
                            f = ErpScope.pushFilter(f, db.tables.party_type, "company_id", ErpScope.getCompanyId());
                            f = ErpScope.pushFilter(f, db.tables.party_type, "branch_id", ErpScope.getBranchId());
                            return this.props.servers.erp.party_type.List(f, page, size, sorts, null);
                        }}
                        getValue={(item) => item.id} getTitle={(item) => item.name} getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxString ref={this.Name} required title="Name" info={{ link: "https://namirasoft.com/erp/console-guide/party/#field-name" }} style={{ width: NSBox.width.double }} />
                    <NSBoxTextArea ref={this.Description} required={false} title="Description" info={{ link: "https://namirasoft.com/erp/console-guide/party/#field-description" }} style={{ width: NSBox.width.double }} />
                    <NSBoxBoolean ref={this.Enabled} required checked={true} title="Enabled" info={{ link: "https://namirasoft.com/erp/console-guide/party/#field-enabled" }} style={{ width: NSBox.width.double }} />
                </NSColumn>
            </ErpLayout>
        );
    }
}